import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Tab, TabList, TabPanel, Tabs, TabsSize } from '../../components/Tabs/Tabs';
import { Bem } from '../../service/Bem/Bem';
import { CanvasAppContext } from '../common/typings';
import { Html5ArchiveContainer } from '../Html5Archive/Html5ArchiveContainer';
import { Html5CreativesContainer } from '../Html5Creatives/Html5CreativesContainer';
import { Html5UploadContainer } from '../Html5Upload/Html5UploadContainer';

import './Html5App.css';
import * as keyset from './Html5App.i18n';
import { Html5Page } from './typings';

const i18n = i18nFactory(keyset);

const indexToPage = [Html5Page.ACTIVE, Html5Page.UPLOAD, Html5Page.ARCHIVE];

export type OwnProps = {
    page: Html5Page;
    onClose: () => void;
    onCreativesSelect: (ids: number[]) => void;
};

export type Html5AppProps = {
    changePage: (page: Html5Page) => void;
} & OwnProps;

export interface Html5AppState {
    isLoading: boolean;
}

const BLOCK = 'html5-app';

export class Html5App extends React.Component<Html5AppProps, Html5AppState> {
    private ref = React.createRef<HTMLDivElement>();

    constructor(props: Html5AppProps) {
        super(props);

        this.state = { isLoading: false };
    }

    render() {
        const { onClose, onCreativesSelect } = this.props;

        return (
            <div className={BLOCK} ref={this.ref}>
                <Tabs
                    size={TabsSize.s}
                    selectedIndex={indexToPage.indexOf(this.props.page)}
                    onSelect={this.onSelectTab}
                    className={Bem.cls(BLOCK, 'tabs')}
                >
                    <div className={Bem.cls(BLOCK, 'tabs-list-wrapper')}>
                        <TabList>
                            <Tab>{i18n('creatives')}</Tab>
                            <Tab>{i18n('upload')}</Tab>
                            <Tab>{i18n('archive')}</Tab>
                        </TabList>
                    </div>

                    <TabPanel
                        className={Bem.cls(BLOCK, 'tab-panel', {
                            active: this.props.page === Html5Page.ACTIVE
                        })}
                    >
                        <CanvasAppContext.Provider value={{ parent: this.ref.current }}>
                            <Html5CreativesContainer onCreativesSelect={onCreativesSelect} cancel={onClose} />
                        </CanvasAppContext.Provider>
                    </TabPanel>

                    <TabPanel
                        className={Bem.cls(BLOCK, 'tab-panel', {
                            active: this.props.page === Html5Page.UPLOAD
                        })}
                    >
                        <Html5UploadContainer />
                    </TabPanel>

                    <TabPanel
                        className={Bem.cls(BLOCK, 'tab-panel', {
                            active: this.props.page === Html5Page.ARCHIVE
                        })}
                    >
                        <CanvasAppContext.Provider value={{ parent: this.ref.current }}>
                            <Html5ArchiveContainer cancel={onClose} />
                        </CanvasAppContext.Provider>
                    </TabPanel>
                </Tabs>
            </div>
        );
    }

    private onSelectTab = (index: number) => {
        this.props.changePage(indexToPage[index]);
    };
}
